import { Clinic, ClinicInfoDtoToDomain } from '../../2_domain/clinic/clinic';
import IClinicRepository, {
  ClinicUpdateDto,
} from '../../2_domain/clinic/iClinicRepository';
import {
  Notice,
  NoticeDto,
  noticeFromDto,
  NoticeSummary,
  noticeSummaryFromDto,
} from '../../2_domain/notice/notice';
import Get from '../../lib/di/get';
import Connection from '../core/connection';
import Connection2 from '../core/connection2';
import { GET_NOTICES, GET_NOTICE_BY_ID } from './clinicQuery';

class ClinicRepository implements IClinicRepository {
  //LINK - id 20
  getClinicInformation = async (): Promise<Clinic> => {
    const { code, ...res } = await Connection2.requestGet(
      'clinic/queryClinicMyInfo'
    );
    return ClinicInfoDtoToDomain(res);
  };

  //LINK - id 23
  updateClinicInformation = async (
    clinicUpdateDto: ClinicUpdateDto
  ): Promise<void> => {
    await Connection2.requestPatch(
      'clinic/updateClinicMyInfo',
      clinicUpdateDto
    );
    return;
  };

  //LINK - id 21
  //NOTE - NA
  getClinicNotices = async (
    pagination: Pagination
  ): Promise<PageResult<NoticeSummary>> => {
    const connection = Get.find<Connection>('Connection');
    const client = connection.getClient();
    const res = await client.query({
      query: GET_NOTICES,
      fetchPolicy: 'cache-first',
      variables: {
        input: {
          pagination: pagination,
        },
      },
    });
    return {
      page: res.data['queryClinicNoticeList']['page'],
      list: res.data['queryClinicNoticeList']['list'].map((dto: NoticeDto) =>
        noticeSummaryFromDto(dto)
      ),
    };
  };

  //LINK - id 22
  //NOTE - NA
  getClinicNoticeById = async (noticeId: number): Promise<Notice> => {
    const connection = Get.find<Connection>('Connection');
    const client = connection.getClient();
    const res = await client.query({
      query: GET_NOTICE_BY_ID,
      fetchPolicy: 'cache-first',
      variables: {
        input: noticeId,
      },
    });
    return noticeFromDto(res.data['queryClinicNoticeById']);
  };
}

export default ClinicRepository;
